const { ASYNC, ERROR, SIMPLE } = require('../utils/redux-helpers');

module.exports = {
    LOGIN: ASYNC,
    START_MFA_SETUP: ASYNC,
    RESEND_MFA_CHALLENGE: ASYNC,
    RESET_MFA_PHONE: ASYNC,
    VERIFY_MFA: ASYNC,
    UPDATE_LOGIN_CONTEXT: SIMPLE,
    LOGIN_TOKEN: ASYNC,
    LOGOUT: ASYNC,
    LOGIN_SSO_TOKEN: ASYNC,
    CLOSE_ACCOUNT: ASYNC,
    ACCOUNT_CLOSED_CLEAR: SIMPLE,
    LOGOUT_SYNC: SIMPLE,
    LOGIN_INPUT_FAILURE: ERROR,
    REQUEST_PASSWORD_RESET: ASYNC,
    RESET_PASSWORD: ASYNC,
    CHECK_RESET_TOKEN: ASYNC,
    UPDATE_TWILIO_TOKEN: ASYNC
};
